/**
 * @Author:  chengmingyuan
 * @Date:  2020-12-24
 * @Description: constants value
 **/
// export const ALL_TODOS = 'all'
// export const ACTIVE_TODOS = 'active'
// export const COMPLETED_TODOS = 'completed'
export const ENTER_KEY = 'Enter';
export const ESCAPE_KEY = 'Escape';

export enum TodoStatus { ALL_TODOS = 'ALL_TODOS', ACTIVE_TODOS = 'ACTIVE_TODOS', COMPLETED_TODOS = 'COMPLETED_TODOS'}

